import { MARGINS_BLOCKS } from '@features/cms/const';
import { TMarginsTypes } from '@features/cms/typescript';
import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  collectionSection: (bg: string, marginTop: TMarginsTypes, marginBottom: TMarginsTypes) => ({
    bg,
    pt: MARGINS_BLOCKS[marginTop],
    pb: MARGINS_BLOCKS[marginBottom],
    position: 'relative'
  }),
  styledDescription: (color: string) => ({
    maxWidth: 988,
    m: '24px 0',
    color
  }),
  tagsWrapper: {
    borderBottom: `1px solid ${theme.rawColors.lightGrey700}}`,
    position: 'relative',
    mb: '40px'
  },
  tagsContainer: {
    '&.keen-slider': {
      mb: '-1px',
      overflow: 'visible',
      display: 'flex',
      '.keen-slider__slide': {
        maxWidth: 'min-content',
        width: 'min-content',
        minWidth: 'min-content'
      }
    }
  },
  tagButton: (active: boolean) => ({
    '&.keen-slider__slide': {
      ...reusables.mainTransition('border-color'),
      bg: 'transparent',
      display: 'block',
      border: 'none',
      borderBottom: `1px solid ${active ? theme.rawColors.neutralBlack : theme.rawColors.lightGrey700}`,
      p: '4px 16px',
      fontSize: theme.fontSizes.smallText,
      lineHeight: '140%',
      position: 'relative',
      overflow: 'visible',
      span: {
        height: 20,
        pt: '3px',
        minWidth: 'max-content',
        display: 'flex'
      },
      '&:hover': {
        borderColor: theme.rawColors.neutralBlack
      }
    }
  }),
  container: {
    position: 'relative',
    pl: [40, 40, 64, 195],
    pr: [40, 40, 64, 195]
  },
  sliderContainer: {
    '&.keen-slider': {
      overflow: 'visible',
      m: ['32px 0 22px', '32px 0 22px', '32px 0 22px', '40px 0 30px']
    }
  },
  slideBox: {
    position: 'relative',
    maxWidth: [295, 295, 318, 442],
    minWidth: [295, 295, 318, 442],
    width: [295, 295, 318, 442],
    height: [393, 393, 424, 560],
    svg: {
      ...reusables.mainTransition('transform')
    },
    '&:hover svg': {
      transform: 'translateX(-16px)'
    }
  },
  slideContent: {
    position: 'absolute',
    bottom: 40,
    left: 40,
    right: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: '4px'
  },
  scrollbar: {
    height: 'auto',
    overflowX: 'auto',
    overflowY: 'hidden',
    position: 'relative',
    '&::-webkit-scrollbar': {
      height: '10px',
      position: 'relative'
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
      borderBottom: `2px solid ${theme.rawColors.lightGrey700}`
    },
    '&::-webkit-scrollbar-thumb': {
      position: 'relative',
      top: '10px',
      background: 'transparent',
      borderBottom: `2px solid ${theme.rawColors.darkGrey700}`
    }
  }
};